import { cn } from '../../lib/utils';

interface FormFieldProps {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormField({ label, required, hint, error, children, className }: FormFieldProps) {
  return (
    <div className={cn(className)}>
      <div className="flex items-center justify-between mb-1.5">
        <label className="block text-sm font-medium text-gray-800">
          {label}
          {required && <span className="ml-0.5 text-error-500 text-xs">*</span>}
        </label>
        {hint && <span className="text-xs text-gray-400">{hint}</span>}
      </div>
      {children}
      {error && <p className="mt-1 text-xs text-error-600">{error}</p>}
    </div>
  );
}
